import gql from 'graphql-tag';
import { FREEFOOD_SETUP_CONTROL_PHOTOS_FRAGMENT, FREEFOOD_SETUP_FRAGMENT } from './freefoodSetup';
import {
    MICROSTORE_COLUMN_GROUP_SETUP_CONTROL_PHOTOS_FRAGMENT,
    MICROSTORE_COLUMN_GROUP_SETUP_FRAGMENT,
} from './microstoreColumnGroupSetup';
import { SITE_WITH_LOCATION_INFO_FRAGMENT } from 'data/fragments/site';

export const SITE_SETUP_FRAGMENT = gql`
    fragment SiteSetupFragment on SiteSetup {
        _id
        createdAt
        date
        delivery {
            isDynamic
        }
        deliveryPerson {
            _id
            fullname
        }
        deliveryId
        freefoodSetup {
            ...FreefoodSetupFragment
        }
        isFinishForced
        issues {
            productsIssues {
                comment
                productId
                brokenDuringDeliveryQuantity
                brokenOnSiteAfterInventoryQuantity
                brokenOnSiteBeforeInventoryQuantity
                expiredDeliveredQuantity
                expiredOnSiteAfterInventoryQuantity
                expiredOnSiteBeforeInventoryQuantity
                notEnoughPlaceQuantity
                otherBeforeInventoryQuantity
                otherAfterInventoryOrDuringDeliveryQuantity
                unexpectedOnSiteQuantity
                wrongQuantityDelivered
            }
        }
        microstoreColumnGroupSetups {
            ...MicrostoreColumnGroupSetupFragment
        }
        tickets {
            _id
            odooId
            odooRef
            name
            isClosed
            stage {
                name
            }
            team {
                name
            }
            ticketType {
                name
            }
            actions {
                actionType
                message
                photoUrl
                createdAt
            }
            microstoreColumn {
                name
            }
        }
        siteId
        site {
            ...SiteWithLocationInfoFragment
        }
        state
        stateHistory {
            createdAt
            createdBy
            createdByName
            state
        }
        updatedAt
    }
    ${FREEFOOD_SETUP_FRAGMENT}
    ${MICROSTORE_COLUMN_GROUP_SETUP_FRAGMENT}
    ${SITE_WITH_LOCATION_INFO_FRAGMENT}
`;

export const SITE_SETUP_CONTROL_PHOTOS_FRAGMENT = gql`
    fragment SiteSetupControlPhotosFragment on SiteSetup {
        _id
        date
        freefoodSetup {
            ...FreefoodSetupControlPhotosFragment
        }
        microstoreColumnGroupSetups {
            ...MicrostoreColumnGroupSetupControlPhotosFragment
        }
    }
    ${FREEFOOD_SETUP_CONTROL_PHOTOS_FRAGMENT}
    ${MICROSTORE_COLUMN_GROUP_SETUP_CONTROL_PHOTOS_FRAGMENT}
`;
